import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { formatPartialDate } from 'Utility/date';
import { sortDocumentsDescending } from 'Utility/documentHandling';

const AriaSymptomsDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  const latestDoc = documents.toSorted(sortDocumentsDescending).at(0);

  const symptomRows = 4;

  const data = latestDoc?.symptoms
    ? [
        {
          date: latestDoc.date ? formatPartialDate(latestDoc.date) : '-',
          key: 'symptoms',
          title: fm('ariaSymptoms.symptoms'),
          value: (
            <ul style={{ margin: 0 }}>
              {(latestDoc.symptoms.length > symptomRows + 1
                ? [...latestDoc.symptoms].slice(0, symptomRows)
                : latestDoc.symptoms
              ).map(symp => (
                <li key={symp}>{fm(`ariaSymptoms.opts.${symp}`)}</li>
              ))}
              {symptomRows + 1 < latestDoc.symptoms.length ? (
                <div>{`+ ${latestDoc.symptoms.length - symptomRows} ${fm('ariaSymptoms.other')}`}</div>
              ) : undefined}
            </ul>
          ),
        },
      ]
    : [
        {
          date: latestDoc?.date ? formatPartialDate(latestDoc.date) : '-',
          key: 'date',
          title:
            latestDoc?.symptomsFound === 'yes'
              ? fm('ariaSymptoms.symptomsFound')
              : latestDoc?.symptomsFound === 'no'
                ? fm('ariaSymptoms.noSymptoms')
                : '-',
        },
      ];

  return <TileContentMaker type="specificListMultipleRows" itemsCanFitAmount={2} data={data} />;
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'ariaSymptoms'>>;
}

export default AriaSymptomsDash;
